import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface UserState {
  isLogged: boolean;
  name: string | null;
  email: string | null;
  isAdmin: boolean;
}

const initialState: UserState = {
  isLogged: false,
  name: null,
  email: null,
  isAdmin: false
};

const userSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    login(state, action) {
      state.isLogged = true;
      state.name = action.payload.userName;
      state.email = action.payload.email;
      state.isAdmin = action.payload.permissions?.includes('admin') || false;
    },
    logout(state) {
      state.isLogged = false;
      state.name = null;
      state.email = null;
      state.isAdmin = false;
    }
  }
});

export const { login, logout } = userSlice.actions;
export const userInfoSelector = (state: RootState) => state.userInfo;
export default userSlice.reducer;
